/**
 * The ground the whole product sits on.
 *
 * Four blurred colour fields drift across a warm surface, with a vignette weighting the
 * bottom of the frame. Everything above it is frosted glass, and frosted glass over a flat
 * colour reads as grey plastic — the aurora is what gives the panels something to refract,
 * and it is the reason the shell feels like a lit room rather than a page.
 *
 * The geometry, the drift cycles and the colours all live in `styles/surfaces.css`; this
 * component is only the markup, because the layer is `pointer-events: none`, `aria-hidden`
 * and `contain: strict` and there is nothing per-instance to configure.
 *
 * A deployment that wants it calmer sets `--aurora-opacity` — including to `0`, which leaves
 * a plain warm desk and costs nothing else. Reduced-motion stops the drift outright rather
 * than speeding it to 0.01ms, which would snap every field to its halfway keyframe.
 */
export const Desk = () => (
  <>
    <div className="aurora" aria-hidden>
      <i />
      <i />
      <i />
      <i />
    </div>
    <div className="vignette" aria-hidden />
  </>
)
